import { render, staticRenderFns } from "./SubscriptionKeyForm.vue?vue&type=template&id=5957139c"
import script from "./SubscriptionKeyForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionKeyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports